import $api from "..";
import {AxiosResponse} from "axios";
import {IChangePassword} from "../common/api_interfaces/user/IChangePassword";
import { IRecoverPassword } from "../common/api_interfaces/user/IRecoverPassword";
import { IFullUserInfo, IUserInfo } from "../common/api_interfaces/user/IUserInfo";

export default class AuthService {
    static async login(email: string, password: string): Promise<AxiosResponse<IUserInfo>> {
        return $api.post<IUserInfo>('/login', {email, password});
    }

    static async loginOAuth(access_token: string) : Promise<AxiosResponse<IUserInfo>>{
        return $api.post<IUserInfo>('/login', {access_token, isOauth: true});
    }

    static async registration(email: string, password: string, name: string, surname: string, middlename: string): Promise<AxiosResponse<IUserInfo>> {
        return $api.post<IUserInfo>('/registration', {email, password, name, surname, middlename});
    }

    static async logout(): Promise<AxiosResponse<void>> {
        return $api.post('/logout');
    }

    static async checkActivate(email: string): Promise<AxiosResponse<IUserInfo>> {
        return $api.post<IUserInfo>('/chekactivate', {email});
    }

    static async activatePerson(link: string): Promise<AxiosResponse<any>> {
        return $api.get<any>(`/activate?link=${link}`);
    }

    static async fetchCurentUser(): Promise<AxiosResponse<IFullUserInfo>> {
        return $api.get<IFullUserInfo>('/getCurrentUser');
    }

    static async requestPasswordRecover(email: string) {
        return $api.post("/requestPasswordRecover", {email});
    }

    static async recoverPassword(body: IRecoverPassword) {
        return $api.post("/recoverPassword", body);
    }

    static async changePassword(data: IChangePassword): Promise<AxiosResponse> {
        return $api.post<AxiosResponse>('/changePassword', data);
    }
}